module.exports = __webpack_public_path__ + "static/media/Oppaat_ei_sis_hh_2013_SUOMI.2f43b2ed.png";